(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 9208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(7317);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Body; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9863);


const Body = (param)=>{
    let { children , ...props } = param;
    const { Body: BodyTheme  } = (0,hooks_useComponentsTheme__WEBPACK_IMPORTED_MODULE_1__/* .useComponentsTheme */ .U)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BodyTheme, {
        ...props,
        children: children
    });
};


/***/ }),

/***/ 5036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ SectionTitle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/SectionTitle/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          a {\n            text-decoration: none;\n            cursor: pointer;\n\n            transition: opacity ease-in 0.3s;\n\n            &:hover {\n              opacity: 0.5;\n            }\n          }\n        "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          pointer-events: none;\n        "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  ",
        "\n\n  h2 {\n    position: relative;\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: ",
        ";\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n    text-align: center;\n  }\n\n  > div {\n    height: 1px;\n    background-color: ",
        ";\n    flex: 1;\n  }\n\n  @media (max-width: 768px) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-f27c4c57-0"
})(_templateObject2(), (p)=>p.theme.spacing.large, (p)=>p.theme.spacing.xxLarge, (param)=>{
    let { hasHref  } = param;
    return hasHref ? (0,styled_components_browser_esm/* css */.iv)(_templateObject()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
}, (p)=>p.theme.font.large, (p)=>p.theme.colors.primary, (p)=>p.theme.colors.border, (p)=>p.theme.spacing.xLarge);

;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/SectionTitle/index.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 


const SectionTitle = (param)=>{
    let { title , href =""  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        hasHref: !!href,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: href,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
};


/***/ }),

/***/ 3869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ SectionWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9521);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  display: flex;\n  flex-direction: column;\n\n  padding-top: ",
        ";\n\n  @media (max-width: 768px) {\n    padding-top: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const SectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-b2998cd3-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.spacing.xxLarge;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xLarge;
});


/***/ }),

/***/ 3756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useMediaQuery(query) {
    const [matches, setMatches] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = ()=>{
            setMatches(media.matches);
        };
        media.addEventListener("change", listener);
        return ()=>media.removeEventListener("change", listener);
    }, [
        matches,
        query
    ]);
    return matches;
}


/***/ }),

/***/ 7317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./src/components/Showcases/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  padding-bottom: ",
        ";\n\n  @media (max-width: 768px) {\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-699d33e0-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.spacing.xxLarge;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xLarge;
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(3756);
// EXTERNAL MODULE: ./src/components/Body/index.tsx
var Body = __webpack_require__(3405);
;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/SimpleBanners/styles.ts
/* eslint-disable no-nested-ternary */ 
function styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            flex-wrap: wrap;\n          "
    ]);
    styles_templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n            flex-direction: column;\n          "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n\n  @media (max-width: 768px) {\n    gap: ",
        ";\n\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        pointer-events: initial;\n\n        &:hover {\n          opacity: 0.7;\n        }\n      "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  width: 100%;\n  max-width: 100%;\n\n  aspect-ratio: ",
        ";\n\n  overflow: hidden;\n\n  @media (max-width: 768px) {\n    aspect-ratio: ",
        ";\n  }\n\n  > a {\n    height: 100%;\n    width: 100%;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    transition: opacity ease-in 0.3s;\n\n    pointer-events: none;\n\n    ",
        "\n\n    > img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}

const SimpleBannersList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-4bac2b36-0"
})(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.spacing.xLarge;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.medium;
}, (param)=>{
    let { itemsCount  } = param;
    return itemsCount === 3 ? (0,styled_components_browser_esm/* css */.iv)(styles_templateObject()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
const SimpleBannerItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-4bac2b36-1"
})(_templateObject4(), (param)=>{
    let { itemsCount  } = param;
    return itemsCount === 3 ? "500 / 500" : itemsCount === 2 ? "502 / 200" : "1036 / 200";
}, (param)=>{
    let { itemsCount  } = param;
    return itemsCount === 3 ? "500 / 500" : itemsCount === 2 ? "768 / 200" : "768 / 200";
}, (param)=>{
    let { hasUrl  } = param;
    return hasUrl && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
});

// EXTERNAL MODULE: ./src/components/Showcases/Showcase/styles.ts
var styles = __webpack_require__(3869);
;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/SimpleBanners/index.tsx
/* eslint-disable jsx-a11y/anchor-is-valid */ 





const SimpleBanners = (param)=>{
    let { showcase  } = param;
    const isScreenIn768px = (0,useMediaQuery/* useMediaQuery */.a)("(max-width: 768px)");
    const activeSimpleBanners = !(showcase === null || showcase === void 0 ? void 0 : showcase.simpleBanners) || showcase.simpleBanners.length === 0 ? [] : showcase.simpleBanners.filter((simpleBanner)=>simpleBanner.status === "active");
    if (!activeSimpleBanners || activeSimpleBanners.length === 0) return null;
    const itemsCount = activeSimpleBanners.length || 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* Body */.u, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SectionWrapper */.U, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleBannersList, {
                itemsCount: itemsCount,
                children: activeSimpleBanners.map((simpleBanner)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleBannerItem, {
                        hasUrl: !!simpleBanner.url,
                        itemsCount: itemsCount,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: simpleBanner.url || "",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: simpleBanner.description,
                                src: isScreenIn768px && !!simpleBanner.mobilePicture ? simpleBanner.mobilePicture : simpleBanner.desktopPicture
                            })
                        })
                    }, simpleBanner._id))
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/BrandsCarrousel/styles.ts

function BrandsCarrousel_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-prev,\n  .slick-next {\n    width: 40px;\n    height: 40px;\n  }\n\n  .slick-prev {\n    left: -40px;\n  }\n\n  .slick-next {\n    right: -40px;\n  }\n"
    ]);
    BrandsCarrousel_styles_templateObject = function() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n\n  @media (max-width: 768px) {\n    padding: ",
        ";\n  }\n\n  > a {\n    margin: 0 auto;\n\n    max-width: 248px;\n    width: 100%;\n    height: 80px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    transition: opacity ease-in 0.3s;\n\n    &:hover {\n      opacity: 0.7;\n    }\n\n    > img {\n      height: 80px;\n      width: auto;\n      margin: 0 auto;\n\n      object-position: center;\n      object-fit: contain;\n    }\n\n    > span {\n      font-size: 14px;\n      text-transform: uppercase;\n      line-height: 20px;\n\n      color: ",
        ";\n      font-weight: 600;\n    }\n  }\n"
    ]);
    styles_templateObject1 = function() {
        return data;
    };
    return data;
}

const SliderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eb419cde-0"
})(BrandsCarrousel_styles_templateObject());
const SlideItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eb419cde-1"
})(styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return "0 ".concat(theme.spacing.medium);
}, (param)=>{
    let { theme  } = param;
    return "0 ".concat(theme.spacing.small);
}, (param)=>{
    let { theme  } = param;
    return theme.colors.textDark;
});

// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(6893);
;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/BrandsCarrousel/CustomArrow/styles.ts

function CustomArrow_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          right: 0;\n        "
    ]);
    CustomArrow_styles_templateObject = function() {
        return data;
    };
    return data;
}
function CustomArrow_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          left: 0;\n        "
    ]);
    CustomArrow_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n\n  width: 40px;\n  height: 40px;\n\n  ",
        "\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  cursor: pointer;\n\n  transition: opacity ease-in 0.3s;\n\n  &:hover {\n    opacity: 0.6;\n  }\n\n  > svg {\n    min-width: 40px;\n    min-height: 40px;\n    color: #999;\n  }\n"
    ]);
    styles_templateObject2 = function() {
        return data;
    };
    return data;
}

const styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6aee7ab2-0"
})(styles_templateObject2(), (param)=>{
    let { variant  } = param;
    return variant === "next" ? (0,styled_components_browser_esm/* css */.iv)(CustomArrow_styles_templateObject()) : (0,styled_components_browser_esm/* css */.iv)(CustomArrow_styles_templateObject1());
});

;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/BrandsCarrousel/CustomArrow/index.tsx



const CustomArrow = (param)=>{
    let { variant  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Container, {
        variant: variant,
        children: variant === "prev" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiChevronLeft */.YFh, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiChevronRight */.Tfp, {})
    });
};

// EXTERNAL MODULE: ./src/components/Showcases/Showcase/SectionTitle/index.tsx + 1 modules
var SectionTitle = __webpack_require__(5036);
;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/BrandsCarrousel/index.tsx
/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable jsx-a11y/anchor-is-valid */ 







const BrandsCarrousel = (param)=>{
    let { showcase  } = param;
    var ref;
    const activeBrands = !(showcase === null || showcase === void 0 ? void 0 : showcase.brands) || ((ref = showcase.brands) === null || ref === void 0 ? void 0 : ref.length) === 0 ? [] : showcase.brands.filter((brand)=>brand.status === "active");
    if (!activeBrands || activeBrands.length === 0) return null;
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: activeBrands.length >= 4 ? 4 : activeBrands.length,
        slidesToScroll: 1,
        speed: 400,
        arrows: true,
        centerMode: true,
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomArrow, {
                variant: "prev"
            })
        }),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomArrow, {
                variant: "next"
            })
        }),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: activeBrands.length >= 3 ? 3 : activeBrands.length
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: activeBrands.length >= 2 ? 2 : activeBrands.length
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* Body */.u, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* SectionWrapper */.U, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
                    title: showcase.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                        ...settings,
                        children: activeBrands.map((brand)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SlideItem, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/marcas/".concat(brand._id),
                                    children: brand.picture ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: brand.name,
                                        src: brand.picture
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: brand.name
                                    })
                                })
                            }, brand._id))
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Showcase_BrandsCarrousel = (BrandsCarrousel);

;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/Benefits/styles.ts

function Benefits_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n\n  @media (max-width: 768px) {\n    padding: ",
        ";\n  }\n"
    ]);
    Benefits_styles_templateObject = function() {
        return data;
    };
    return data;
}
function Benefits_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      pointer-events: initial;\n\n      &:hover {\n        opacity: 0.7;\n      }\n    "
    ]);
    Benefits_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function Benefits_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  width: 100%;\n  max-width: ",
        ";\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n\n  transition: opacity ease-in 0.3s;\n\n  pointer-events: none;\n\n  ",
        "\n\n  > img {\n    height: 36px;\n    width: 36px;\n    object-fit: contain;\n    object-position: center;\n    margin-bottom: ",
        ";\n  }\n\n  > strong {\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 14px;\n    color: ",
        ";\n    overflow: hidden;\n    max-width: 100%;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-transform: uppercase;\n    text-align: center;\n  }\n\n  > div {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 18px;\n    color: #444;\n\n    white-space: normal;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    text-align: center;\n  }\n"
    ]);
    Benefits_styles_templateObject2 = function() {
        return data;
    };
    return data;
}

const styles_SlideItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d129d142-0"
})(Benefits_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return "0 ".concat(theme.spacing.medium);
}, (param)=>{
    let { theme  } = param;
    return "0 ".concat(theme.spacing.small);
});
const BenefitItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d129d142-1"
})(Benefits_styles_templateObject2(), (param)=>{
    let { theme  } = param;
    return "calc(200px - ".concat(theme.spacing.medium, " - 36px)");
}, (p)=>p.theme.spacing.small, (param)=>{
    let { hasUrl  } = param;
    return hasUrl && (0,styled_components_browser_esm/* css */.iv)(Benefits_styles_templateObject1());
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.small;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.textDark;
});

;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/Benefits/CustomArrow/styles.ts

function Benefits_CustomArrow_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          right: 0;\n        "
    ]);
    Benefits_CustomArrow_styles_templateObject = function() {
        return data;
    };
    return data;
}
function Benefits_CustomArrow_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          left: 0;\n        "
    ]);
    Benefits_CustomArrow_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function CustomArrow_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  width: 40px;\n  height: 40px;\n\n  ",
        "\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  cursor: pointer;\n\n  transition: opacity ease-in 0.3s;\n\n  &:hover {\n    opacity: 0.6;\n  }\n\n  > svg {\n    min-width: 40px;\n    min-height: 40px;\n    color: #999;\n  }\n"
    ]);
    CustomArrow_styles_templateObject2 = function() {
        return data;
    };
    return data;
}

const CustomArrow_styles_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a3c5cd5c-0"
})(CustomArrow_styles_templateObject2(), (param)=>{
    let { variant  } = param;
    return variant === "next" ? (0,styled_components_browser_esm/* css */.iv)(Benefits_CustomArrow_styles_templateObject()) : (0,styled_components_browser_esm/* css */.iv)(Benefits_CustomArrow_styles_templateObject1());
});

;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/Benefits/CustomArrow/index.tsx



const CustomArrow_CustomArrow = (param)=>{
    let { variant  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomArrow_styles_Container, {
        variant: variant,
        children: variant === "prev" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiChevronLeft */.YFh, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiChevronRight */.Tfp, {})
    });
};

;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/Benefits/index.tsx
/* eslint-disable @next/next/no-img-element */ /* eslint-disable react/no-danger */ /* eslint-disable jsx-a11y/anchor-is-valid */ 






const Benenefits = (param)=>{
    let { showcase  } = param;
    var ref;
    const activeBenefits = !(showcase === null || showcase === void 0 ? void 0 : showcase.benefits) || ((ref = showcase.benefits) === null || ref === void 0 ? void 0 : ref.length) === 0 ? [] : showcase.benefits.filter((benefit)=>benefit.status === "active");
    if (!activeBenefits || activeBenefits.length === 0) return null;
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: activeBenefits.length >= 5 ? 5 : activeBenefits.length,
        slidesToScroll: 1,
        speed: 400,
        arrows: true,
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomArrow_CustomArrow, {
                variant: "prev"
            })
        }),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomArrow_CustomArrow, {
                variant: "next"
            })
        }),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: activeBenefits.length >= 4 ? 4 : activeBenefits.length
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: activeBenefits.length >= 3 ? 3 : activeBenefits.length
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: activeBenefits.length >= 2 ? 2 : activeBenefits.length
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* Body */.u, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SectionWrapper */.U, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                ...settings,
                children: activeBenefits.map((benefit)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(styles_SlideItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: benefit.url || "",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BenefitItem, {
                                hasUrl: !!benefit.url,
                                children: [
                                    !!benefit.picture && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: benefit.picture,
                                        alt: benefit.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: benefit.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: benefit.description
                                        }
                                    })
                                ]
                            })
                        })
                    }, benefit._id))
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Showcases/Showcase/index.tsx






const SimpleListProducts = dynamic_default()(()=>__webpack_require__.e(/* import() */ 625).then(__webpack_require__.bind(__webpack_require__, 5625)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5625)
            ]
    }
});
const RotationBanners = dynamic_default()(()=>__webpack_require__.e(/* import() */ 566).then(__webpack_require__.bind(__webpack_require__, 1566)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(1566)
            ]
    }
});
const Showcase = (param)=>{
    let { showcase  } = param;
    return (0,react.useMemo)(()=>{
        return ({
            rotation_banners: /*#__PURE__*/ (0,jsx_runtime.jsx)(RotationBanners, {
                showcase: showcase
            }),
            products_simple_list: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleListProducts, {
                showcase: showcase
            }),
            brands_carousel: /*#__PURE__*/ (0,jsx_runtime.jsx)(Showcase_BrandsCarrousel, {
                showcase: showcase
            }),
            benefits: /*#__PURE__*/ (0,jsx_runtime.jsx)(Benenefits, {
                showcase: showcase
            }),
            simple_banners: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleBanners, {
                showcase: showcase
            })
        })[(showcase === null || showcase === void 0 ? void 0 : showcase.type) || ""] || null;
    }, [
        showcase
    ]);
};

;// CONCATENATED MODULE: ./src/components/Showcases/index.tsx



const Showcases = (param)=>{
    let { showcases =[]  } = param;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: showcases === null || showcases === void 0 ? void 0 : (ref = showcases.map) === null || ref === void 0 ? void 0 : ref.call(showcases, (showcase)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Showcase, {
                showcase: showcase
            }, showcase._id))
    });
};

;// CONCATENATED MODULE: ./src/pages/index.page.tsx


const Home = (param)=>{
    let { showcases  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Showcases, {
        showcases: showcases
    });
};
var __N_SSP = true;
/* harmony default export */ var index_page = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [893,664,66,774,888,179], function() { return __webpack_exec__(9208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);